/**
 * Le numéro d'émission d'un SMS, ou rien.
 *
 * L'agent choisit un numéro pour ses APPELS. Le lui imposer comme expéditeur
 * de SMS fait échouer l'envoi dès que cette ligne est vocale, ce qui était le
 * cas de deux des trois numéros mesurés le 2026-09-30. Sans expéditeur imposé,
 * le serveur prend le premier numéro du tenant capable d'envoyer.
 */

export interface CallerNumberLite {
  phoneNumber?: string | null;
  capabilities?: string[] | null;
}

export function smsSenderOrAuto(
  chosen: string | null | undefined,
  numbers: CallerNumberLite[] | null | undefined,
): string | undefined {
  if (!chosen) return undefined;
  const n = (numbers || []).find((x) => x.phoneNumber === chosen);
  return n && (n.capabilities || []).includes('sms') ? chosen : undefined;
}

/**
 * Les numeros qui peuvent vraiment envoyer un SMS.
 *
 * Une ligne verifiee comme identifiant d'appelant passe les appels mais pas
 * les SMS (Twilio 21659) : la proposer dans le choix de l'expediteur ferait
 * echouer l'envoi apres coup.
 */
export function smsCapableNumbers(
  numbers: CallerNumberLite[] | null | undefined,
): CallerNumberLite[] {
  return (numbers || []).filter((n) => (n.capabilities || []).includes('sms'));
}

/**
 * Le numero propose par defaut pour repondre.
 *
 * Pierrejean, 2026-09-30 : on appelle un contact tantot d'un numero tantot
 * d'un autre, et le SMS doit partir du meme, sinon la personne recoit un
 * message d'un inconnu. Le numero du dernier appel gagne donc, a condition
 * qu'il sache envoyer des SMS ; sinon le premier qui le sait.
 */
export function defaultSmsSender(
  lastCallNumber: string | null | undefined,
  numbers: CallerNumberLite[] | null | undefined,
): string {
  const capables = smsCapableNumbers(numbers);
  const memeQueLAppel = capables.find((n) => n.phoneNumber === lastCallNumber);
  return memeQueLAppel?.phoneNumber || capables[0]?.phoneNumber || '';
}
